import { render, staticRenderFns } from "./select-address.vue?vue&type=template&id=034f5ab6&scoped=true&"
import script from "./select-address.vue?vue&type=script&lang=ts&"
export * from "./select-address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f5ab6",
  null
  
)

export default component.exports